import { useRef } from "react";

import { Link } from "react-router-dom";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import LMS from "../Assets/lms.png";
import EMS from "../Assets/ems.png";
import CCD from "../Assets/ccd.png";

const OurProducts = () => {
  const carouselRef = useRef();

  const goPrev = () => {
    carouselRef.current.prev(); // OwlCarousel API
  };

  const goNext = () => {
    carouselRef.current.next();
  };

  const options = {
    loop: true,
    margin: 10,
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };

  return (
    <>
      <section id="section11">
        <div className="our_products" id="our-products">
          <div className="heading">
            <h3>
              Our <span>Products</span>
            </h3>
          </div>
          <div className="container-fluid p-0">
            <div className="products-list">
              <OwlCarousel className="owl-theme" ref={carouselRef} {...options}>
                <div className="item">
                  <div className="container">
                    <div className="row m-0">
                      <div className="col-lg-12">
                        <div className="figs">
                          <img src={LMS} className="lms1" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="left">
                          <h5>Learning Management System</h5>
                          <p>
                            Fidus LMS offers complete white labeling and
                            customization options, ensuring alignment with
                            employer branding. Every aspect, from features to
                            color schemes to customizable themes, can be
                            tailored to reflect the organization's identity.
                          </p>
                          <Link to={"/lms"}>
                            <button className="know-more">KNOW MORE</button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item item2">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="figs">
                        <img src={EMS} className="lms1" alt="" />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="left">
                        <h5>The Examiner</h5>
                        <p>
                          Well, isn’t that the whole point? To get insights, the
                          examiner portal gives you the ideal data dashboard
                          that visualizes data to provide you with in depth
                          learner analytics that will help you evaluate the gaps
                          in skills and competencies of your work force. This
                          tool will take your training needs analysis to another
                          level!
                        </p>
                        <Link to={"/examiner"}>
                          <button className="know-more">KNOW MORE</button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="figs">
                        <img src={CCD} className="lms1" alt="" />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="left">
                        <h5>Custom Course Development</h5>
                        <p>
                          Discover personalized learning paths curated to suit
                          your individual needs. Easily acquire new skills
                          efficiently through our intuitive dashboard, which
                          helps you find the most relevant courses and resources
                          aligned with your goals.
                        </p>
                        <Link to={"/custom-course-development"}>
                          <button className="know-more">KNOW MORE</button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </OwlCarousel>
              <div class="owl-nav">
                <button
                  type="button"
                  className="owl-prev"
                  aria-label="Previous"
                  onClick={goPrev}
                >
                  ‹
                </button>
                <button
                  type="button"
                  className="owl-next"
                  aria-label="Next"
                  onClick={goNext}
                >
                  ›
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurProducts;
